import {config, errorCode, errorCodeByType, constans} from './config.js'
import ajax from './api.js'
import Vue from '@/main'
/* import store from '../store/index.js'
let permissionInfo = {}
Object.defineProperty(store.state.admin,'permissionInfo',{
  get:function(){
      return permissionInfo;
  },
  set:function(newValue){
    permissionInfo=newValue;
      console.log('set :',newValue);
      //需要触发的渲染函数可以写在这...
  }
}) */
/*
 所有用户的api
 */
class UserService {
  constructor() {
    // this.tenantId = 1600002912
    // this.authority = process.env.AUTHORITY //是否通过权限拦截
    this.gateway = process.env.GATEWAY//新的网关不走转发
  }
  async getResponse (type, data, authPermission, replaceObj) {
    // data.tenantId=this.tenantId
    let apiType = config[type] || {url: '', method: 'POST'}
    let authority = apiType.authority ? false : process.env.AUTHORITY
    apiType.url = replaceObj ? this.urlReplace(apiType.url, replaceObj) : apiType.url
    let isGwforward = apiType.isGwforward;
    try {
      let response = await ajax(apiType.url, {} ,data, apiType.method, apiType.baseUrl, authPermission || apiType.authPermission, authority,isGwforward)
      if(response){
        response = authority ? this.checkJurisdiction(response, type) : this.checkLogin(response)
        return this.resolve(response, type)
      }
    } catch (e) {
      return Promise.reject(e) // 所有的错误从这返回调用者的catch
    }
  }
  async getResponseByBody (type, urlData, data, authPermission, replaceObj) {
    let apiType = config[type]
    let authority = apiType.authority ? false : process.env.AUTHORITY
    let url = replaceObj ? this.urlReplace(apiType.url, replaceObj) : apiType.url
    let isGwforward = apiType.isGwforward;
    try {
      console.log(authPermission || apiType.authPermission,'1')
      let response = await ajax(url, urlData, data, apiType.method, apiType.baseUrl, authPermission || apiType.authPermission, authority,isGwforward);
      if(response){
        response = authority ? this.checkJurisdiction(response, type) : this.checkLogin(response)
        return this.resolve(response, type)
      }

    } catch (e) {
      return Promise.reject(e) // 所有的错误从这返回调用者的catch
    }
  }
  resolve (response, type) {
    let oData = response.data
    // oData = oData && oData.constructor==String ? JSON.parse(oData) : oData
    // let sErrorCode = oData && oData.status || response.status
    let sErrorCode = response.status
    if(!this.gateway && oData && oData.constructor==String){
      oData = JSON.parse(oData)
      sErrorCode = oData.status
    }
    let oResponseData = !oData || oData.data==undefined ? oData : oData.data
    let errMsg = ((errorCodeByType[type] && errorCodeByType[type][sErrorCode]) || errorCode[sErrorCode] || errorCode[constans['DEFAULT_CODE']])['message']
    let nextName = 'index' // Vue.$route.meta.nextName
    return constans['RIGHT_CODE'].includes(sErrorCode) ? oResponseData : (sErrorCode === constans['REQUIRE_LOGIN'] ? Vue.$router.push({'name': nextName}) : Promise.reject(errMsg))
  }

  urlReplace(url, replaceObj) {
    for(let key in replaceObj) {
      url = url.replace(key, replaceObj[key])
    }
    return url;
  }

  checkJurisdiction (response) {
    let oData = response.data
    let status = oData.status
    if(status == constans['REQUIRE_LOGIN']){// 没有权限则跳转
      let currentUrl = window.location.href
      let paramHref = oData.location;
      paramHref = paramHref.substring(paramHref.indexOf('service=')).replace('service=', '')
      let idx = decodeURIComponent(paramHref).indexOf('?');
      let ins = idx >= 0 ? '&' : '?';
      let location = `${oData.location}${encodeURIComponent(ins + 'backurl='+encodeURIComponent(encodeURIComponent(currentUrl)))}`
      window.location.href = location
    } else {// 有权限
      return oData
    }
  }

  checkLogin(response) {
    let oData = response.data
    let status = oData.status
    if(status == constans['REQUIRE_LOGIN']){// 没有权限则跳转
      let currentUrl = window.location.href
      let paramHref = oData.location;
      paramHref = paramHref.substring(paramHref.indexOf('service=')).replace('service=', '')
      let idx = decodeURIComponent(paramHref).indexOf('?');
      let ins = idx >= 0 ? '&' : '?';
      let location = `${oData.location}${encodeURIComponent(ins + 'backurl='+encodeURIComponent(encodeURIComponent(currentUrl)))}`
      window.location.href = location
    }
    return response
  }
}
export default new UserService()



// WEBPACK FOOTER //
// ./src/api/userService.js